<template>
  <router-view />
</template>

<script>
export default {
  name: 'TransfersIndex'
}
</script>
